export function scrollContentsToTop() {
  const contentsElement = document.getElementById('contents');
  if (contentsElement != null) {
    contentsElement.scrollTop = 0;
  }
}
